<template>
  <div class="formBtn">
    <b-button id="previousStepBtn" @click="onClick"
      ><slot>{{ $t(localeConsts.previousButton) }}</slot></b-button
    >
  </div>
</template>

<script>
export default {
  name: 'PreviousStepButton',
  data() {
    return {
      localeConsts: {
        previousButton: 'STATUSREPORTS.PREVIOUS'
      }
    }
  },
  methods: {
    onClick() {
      this.$emit('clickEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
$text-color: #8b69a9;

#previousStepBtn {
  color: $text-color !important;
  font-weight: bold;
  background-color: white !important;
  border: 2px solid $text-color;
  margin-right: 10px;
}
</style>
